<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

import { accountService } from '@exchange/libs/account/service/src';
import { authService } from '@exchange/libs/auth/service/src';

import LoggedOutOverlay from './LoggedOutOverlay.vue';

const useShowSpinnerWhileLoginOut = () => {
  const showSpinnerWhileLoginOut = ref(false);
  const onLogoutOnXS = (e) => {
    showSpinnerWhileLoginOut.value = e.detail.doing;
  };

  onMounted(() => {
    window.addEventListener('logout-on-xs', onLogoutOnXS, true);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('logout-on-xs', onLogoutOnXS, true);
  });

  return {
    showSpinnerWhileLoginOut,
  };
};

const hasBeenAuthenticated = computed(() => authService.hasBeenAuthenticated);
const initialLoadAuthIsChecked = computed(() => authService.initialLoadAuthIsChecked);
const { accountUserChecksActionRequired } = accountService;

const { showSpinnerWhileLoginOut } = useShowSpinnerWhileLoginOut();

const overlay = computed(() => {
  if (!initialLoadAuthIsChecked.value || showSpinnerWhileLoginOut.value) {
    return {
      show: true,
      spinner: true,
    };
  }

  if (initialLoadAuthIsChecked.value && !hasBeenAuthenticated.value) {
    return {
      show: true,
      spinner: false,
    };
  }

  if (initialLoadAuthIsChecked.value && hasBeenAuthenticated.value && accountUserChecksActionRequired.value) {
    return {
      show: true,
      spinner: true,
    };
  }

  return {
    show: false,
    spinner: false,
  };
});
</script>

<template>
  <div class="exchange-mobile-overlay">
    <logged-out-overlay
      v-if="overlay.show"
      :show-spinner="overlay.spinner"
    />
  </div>
</template>
